/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BenefitDetails {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return BenefitDetails.fixupPrototype; }

    static newInstance(model: Partial<BenefitDetails>): BenefitDetails {
        let obj = Object.assign(new BenefitDetails(), model);
        BenefitDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BenefitDetails>): BenefitDetails {
        if (!model) return null;
        return BenefitDetails.newInstance(<BenefitDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BenefitDetails) {
        if (!obj) return;

        models.BenefitDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BenefitDetails): boolean {
        Object.setPrototypeOf(obj, BenefitDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Source Service account ID of the benefit purchaser.
     */
    source_service_account_id: string;

    /**
     * Commitment discount ID of the savings plan or reservation.
     */
    commitment_discount_id: string;

}
